module.exports = __webpack_public_path__ + "img/c04_unitmangonelgalley_Normal_ua.672652ab.webp";